import React from 'react';

// Minimalist inline icon set for the AdminDashboard sidebar. stroke="currentColor"
// (and fill="currentColor" on the few solid accents) so color follows the
// active/hover/disabled text-color rules already defined in sidebarStyles.
const IconBase = ({ children, size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.75"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {children}
  </svg>
);

export const HomeIcon = (props) => (
  <IconBase {...props}>
    <path d="M4 11L12 4l8 7" />
    <path d="M6 10v9a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-9" />
    <path d="M10 20v-6h4v6" />
  </IconBase>
);

export const UsersIcon = (props) => (
  <IconBase {...props}>
    <circle cx="9" cy="8" r="3" />
    <path d="M4 20c0-3 2.5-5 5-5s5 2 5 5" />
    <circle cx="17" cy="9" r="2.5" />
    <path d="M15 20c.3-2.5 1.8-4 4-4.3" />
  </IconBase>
);

export const SlidersIcon = (props) => (
  <IconBase {...props}>
    <line x1="5" y1="4" x2="5" y2="20" />
    <circle cx="5" cy="9" r="2" />
    <line x1="12" y1="4" x2="12" y2="20" />
    <circle cx="12" cy="15" r="2" />
    <line x1="19" y1="4" x2="19" y2="20" />
    <circle cx="19" cy="7" r="2" />
  </IconBase>
);

export const MapPinIcon = (props) => (
  <IconBase {...props}>
    <path d="M12 21s7-6.5 7-11.5a7 7 0 1 0-14 0C5 14.5 12 21 12 21z" />
    <circle cx="12" cy="9.5" r="2.5" />
  </IconBase>
);

export const BookOpenIcon = (props) => (
  <IconBase {...props}>
    <path d="M12 6c-1.8-1.3-4.2-2-6.5-2S3 4.3 3 4.3v13.4S4.7 17 5.5 17c2.3 0 4.7.7 6.5 2" />
    <path d="M12 6c1.8-1.3 4.2-2 6.5-2S21 4.3 21 4.3v13.4S19.3 17 18.5 17c-2.3 0-4.7.7-6.5 2" />
    <line x1="12" y1="6" x2="12" y2="19" />
  </IconBase>
);

export const ChartBarIcon = (props) => (
  <IconBase {...props}>
    <line x1="4" y1="20" x2="20" y2="20" />
    <rect x="6" y="13" width="3" height="7" />
    <rect x="11" y="9" width="3" height="11" />
    <rect x="16" y="5" width="3" height="15" />
  </IconBase>
);

export const ShieldIcon = (props) => (
  <IconBase {...props}>
    <path d="M12 3l7 3v6c0 5-3.5 7.5-7 9-3.5-1.5-7-4-7-9V6l7-3z" />
    <path d="M9 12l2 2 4-4" />
  </IconBase>
);

export const LockIcon = (props) => (
  <IconBase size={14} {...props}>
    <rect x="5" y="10" width="14" height="9" rx="1.5" />
    <path d="M8 10V7a4 4 0 0 1 8 0v3" />
  </IconBase>
);

export const DocumentIcon = (props) => (
  <IconBase {...props}>
    <path d="M7 3h7l5 5v13H7z" />
    <path d="M14 3v5h5" />
    <line x1="9" y1="13" x2="15" y2="13" />
    <line x1="9" y1="17" x2="15" y2="17" />
  </IconBase>
);

export const MailIcon = (props) => (
  <IconBase {...props}>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="M3 6l9 7 9-7" />
  </IconBase>
);

export const EyeIcon = (props) => (
  <IconBase {...props}>
    <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z" />
    <circle cx="12" cy="12" r="3" />
  </IconBase>
);

export const CalculatorIcon = (props) => (
  <IconBase {...props}>
    <rect x="5" y="3" width="14" height="18" rx="2" />
    <line x1="8" y1="7" x2="16" y2="7" />
    <rect x="8" y="11" width="2" height="2" fill="currentColor" stroke="none" />
    <rect x="12" y="11" width="2" height="2" fill="currentColor" stroke="none" />
    <rect x="16" y="11" width="2" height="2" fill="currentColor" stroke="none" />
    <rect x="8" y="15" width="2" height="2" fill="currentColor" stroke="none" />
    <rect x="12" y="15" width="2" height="2" fill="currentColor" stroke="none" />
    <rect x="16" y="15" width="2" height="2" fill="currentColor" stroke="none" />
  </IconBase>
);

export const SigmaIcon = (props) => (
  <IconBase {...props}>
    <path d="M17 4H7l6 8-6 8h10" />
  </IconBase>
);

export const PencilIcon = (props) => (
  <IconBase {...props}>
    <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
  </IconBase>
);

export const LayersIcon = (props) => (
  <IconBase {...props}>
    <path d="M12 3l9 5-9 5-9-5 9-5z" />
    <path d="M3 13l9 5 9-5" />
  </IconBase>
);

export const ZoomIcon = (props) => (
  <IconBase {...props}>
    <circle cx="11" cy="11" r="7" />
    <line x1="16.5" y1="16.5" x2="21" y2="21" />
  </IconBase>
);

export const ArchiveIcon = (props) => (
  <IconBase {...props}>
    <rect x="3" y="4" width="18" height="5" rx="1" />
    <path d="M5 9v9a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V9" />
    <line x1="10" y1="13" x2="14" y2="13" />
  </IconBase>
);
